import { RouteAuth } from "@/_old/components/auth/route";
import { DEFAULT_ROUTES } from "@/_old/constants/routes";
import { lazy } from "react";
import { Route, Routes } from "react-router-dom";

const PackagesPage = lazy(() => import("@/packages/view"));
const PackageDetailsPage = lazy(() => import("@/packages/details/view"));

const PackagesRoutes = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <RouteAuth permissions={["read-packages"]}>
            <PackagesPage />
          </RouteAuth>
        }
      />
      <Route
        path={DEFAULT_ROUTES.PACKAGE}
        element={
          <RouteAuth permissions={["read-packages"]}>
            <PackageDetailsPage />
          </RouteAuth>
        }
      />
    </Routes>
  );
};

export { PackagesRoutes };
